import { createElement } from 'react';
import { AppRoutes } from './routes/AppRoutes';

function App() {
  return createElement(AppRoutes);
}

export default App;
